<template>
    <div class="setting-width d-flex flex-column justify-content-center">
        <div class="w-100 pb-2">
            <label
                for="gridItem"
                class="font-14"
            >
                Largura - 

                <span v-if="!isFullWidth">Computador</span>

                <span v-else>Computador/Celular</span>
            </label>

            <div class="setting-width--container-input">
                <svg class="setting-width--icon-input" viewBox="0 0 69 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M36 33H13M13 33L23.35 43M13 33L23.35 23" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M33 33H56M56 33L45.65 23M56 33L45.65 43" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <rect width="3" height="65" rx="2.5" fill="#595959"/>
                    <rect x="64" width="3" height="65" rx="2.5" fill="#595959"/>
                </svg>

                <div
                    v-if="isOpen"
                    @mouseleave="isOpen = false"
                    :class="[`setting-width--container--popover setting-width--container--popover--bottom flex-column`]"
                >
                    <button
                        :class="['setting-width--popover-item', { 'active': grid.id === activeGrid.id }]"
                        v-for="grid in grids"
                        :key="grid.id"
                        @click.prevent="setActiveGrid(grid)"
                    >
                        {{ grid.name }}
                    </button>
                </div>

                <div
                    v-if="!isFullWidth"
                    class="w-100"
                >
                    <input
                        id="setting-width--input"
                        @click="isOpen = true"
                        v-b-tooltip.hover
                        :title="activeGrid.name"
                        class="setting-width--input"
                        type="number"
                        v-model.number="inputValue"
                        :min="minValue"
                        :max="maxValue"
                        readonly
                    />

                    <span>%</span>
                </div>
                
                <span 
                    v-else
                    class="setting-width--input-text"
                    @click="isOpen = true"
                >
                    {{ activeGrid.name }}
                </span>


                <div class="setting-width--container-buttons">
                    <button
                        v-b-tooltip.hover
                        title="Aumentar largura"
                        class="setting-width--button-up"
                        @click="increaseValue"
                    >
                        <i class="fal fa-angle-up"></i>
                    </button>

                    <button
                        v-b-tooltip.hover
                        title="Diminuir largura"
                        class="setting-width--button-down"
                        @click="decreaseValue"
                    >
                        <i class="fal fa-angle-down"></i>
                    </button>
                </div>
            </div>
        </div>

        <div
            v-if="!isFullWidth"
            class="w-100 pb-2"
        >
            <label
                for="gridItem"
                class="font-14"
            >
                Largura - Celular
            </label>

            <div class="setting-width--container-input">
                <svg class="setting-width--icon-input" viewBox="0 0 69 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M36 33H13M13 33L23.35 43M13 33L23.35 23" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M33 33H56M56 33L45.65 23M56 33L45.65 43" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <rect width="3" height="65" rx="2.5" fill="#595959"/>
                    <rect x="64" width="3" height="65" rx="2.5" fill="#595959"/>
                </svg>

                <div
                    v-if="isOpenMobile"
                    @mouseleave="isOpenMobile = false"
                    :class="[`setting-width--container--popover setting-width--container--popover--bottom flex-column`]"
                >
                    <button
                        :class="['setting-width--popover-item', { 'active': grid.id === activeGridMobile.id }]"
                        v-for="grid in gridMobileSizes"
                        :key="grid.id"
                        @click.prevent="setActiveGridMobile(grid)"
                    >
                        {{ grid.name }}
                    </button>
                </div>

                <input
                    id="setting-width--input"
                    @click="isOpenMobile = true"
                    v-b-tooltip.hover
                    :title="activeGridMobile.name"
                    class="setting-width--input"
                    type="number"
                    v-model.number="inputValueMobile"
                    :min="minValue"
                    :max="maxValue"
                    readonly
                />

                <span>%</span>

                <div class="setting-width--container-buttons">
                    <button
                        v-b-tooltip.hover
                        title="Aumentar largura"
                        class="setting-width--button-up"
                        @click="increaseValueMobile"
                    >
                        <i class="fal fa-angle-up"></i>
                    </button>

                    <button
                        v-b-tooltip.hover
                        title="Diminuir largura"
                        class="setting-width--button-down"
                        @click="decreaseValueMobile"
                    >
                        <i class="fal fa-angle-down"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameWidth',
    props: {
        item: {
            type: Object,
            required: true
        },
        hasFullWidth: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            isOpen: false,
            isOpenMobile: false,
            activeGrid: null,
            activeGridMobile: null,
            inputValue: 0,
            inputValueMobile: 0,
            columnSize: 0,
            columnSizeMobile: 0,
            minValue: 8,
            maxValue: 110,
            grids: null,
            gridSizes: [
                { id: 1, name: "8% - 1 coluna", value: 1, porcent: 8 },
                { id: 2, name: "16% - 2 colunas", value: 2, porcent: 16 },
                { id: 3, name: "25% - 3 colunas", value: 3, porcent: 25 },
                { id: 4, name: "33% - 4 colunas", value: 4, porcent: 33 },
                { id: 5, name: "41% - 5 colunas", value: 5, porcent: 41 },
                { id: 6, name: "50% - 6 colunas", value: 6, porcent: 50 },
                { id: 7, name: "58% - 7 colunas", value: 7, porcent: 58 },
                { id: 8, name: "66% - 8 colunas", value: 8, porcent: 66 },
                { id: 9, name: "75% - 9 colunas", value: 9, porcent: 75 },
                { id: 10, name: "83% - 10 colunas", value: 10, porcent: 83 },
                { id: 11, name: "91% - 11 colunas", value: 11, porcent: 91 },
                { id: 12, name: "100% - 12 colunas", value: 12, porcent: 100 },
                { id: 13, name: "Largura Total da Tela", value: 99, porcent: 110 },
            ],
            gridMobileSizes: [
                { id: 1, name: "8% - 1 coluna", value: 1, porcent: 8 },
                { id: 2, name: "16% - 2 colunas", value: 2, porcent: 16 },
                { id: 3, name: "25% - 3 colunas", value: 3, porcent: 25 },
                { id: 4, name: "33% - 4 colunas", value: 4, porcent: 33 },
                { id: 5, name: "41% - 5 colunas", value: 5, porcent: 41 },
                { id: 6, name: "50% - 6 colunas", value: 6, porcent: 50 },
                { id: 7, name: "58% - 7 colunas", value: 7, porcent: 58 },
                { id: 8, name: "66% - 8 colunas", value: 8, porcent: 66 },
                { id: 9, name: "75% - 9 colunas", value: 9, porcent: 75 },
                { id: 10, name: "83% - 10 colunas", value: 10, porcent: 83 },
                { id: 11, name: "91% - 11 colunas", value: 11, porcent: 91 },
                { id: 12, name: "100% - 12 colunas", value: 12, porcent: 100 },
            ]
        }
    },
    methods: {
        onChangeWidth() {
            this.$emit('onChangeWidth', this.item)
        },
        increaseValue() {
            const nextGrid = this.gridSizes.find((grid) => grid.porcent > this.inputValue);

            if (nextGrid) {
                this.activeGrid = nextGrid;
            } else {
                this.$bvToast.toast('Você não pode aumentar mais a largura deste item.', {
                    title: 'Atenção',
                    variant: 'warning',
                    solid: true
                });

                this.activeGrid = this.gridSizes[this.gridSizes.length - 1];
            }
        },
        decreaseValue() {
            const prevGrid = this.gridSizes.slice().reverse().find((grid) => grid.porcent < this.inputValue);

            if (prevGrid) {
                this.activeGrid = prevGrid;
            } else {
                this.$bvToast.toast('Você não pode diminuir mais a largura deste item.', {
                    title: 'Atenção',
                    variant: 'warning',
                    solid: true
                });

                this.activeGrid = this.gridSizes[0];
            }
        },
        increaseValueMobile() {
            const nextGrid = this.gridMobileSizes.find((grid) => grid.porcent > this.inputValueMobile);

            if (nextGrid) {
                this.activeGridMobile = nextGrid;
            } else {
                this.$bvToast.toast('Você não pode aumentar mais a largura deste item.', {
                    title: 'Atenção',
                    variant: 'warning',
                    solid: true
                });

                this.activeGrid = this.gridMobileSizes[this.gridMobileSizes.length - 1];
            }
        },
        decreaseValueMobile() {
            const prevGrid = this.gridMobileSizes.slice().reverse().find((grid) => grid.porcent < this.inputValueMobile);

            if (prevGrid) {
                this.activeGridMobile = prevGrid;
            } else {
                this.$bvToast.toast('Você não pode diminuir mais a largura deste item.', {
                    title: 'Atenção',
                    variant: 'warning',
                    solid: true
                });

                this.activeGridMobile = this.gridMobileSizes[0];
            }
        },
        setInitialValue() {
            const grid = this.gridSizes.find((grid) => grid.value == this.item.grid);

            if (grid) {
                this.activeGrid = grid;
            }
        },
        setInitialValueMobile() {
            const grid = this.gridMobileSizes.find((grid) => grid.value == this.item.gridMobile);

            if (grid) {
                this.activeGridMobile = grid;
            }
        },
        setActiveGrid(grid) {
            this.activeGrid = grid;
            this.isOpen = false;
        },
        setActiveGridMobile(grid) {
            this.activeGridMobile = grid;
            this.isOpenMobile = false;
        },
    },
    watch: {
        activeGrid: {
            handler() {
                if (this.activeGrid) {
                    this.inputValue = this.activeGrid.porcent;
                    this.columnSize = this.activeGrid.value;

                    if (this.activeGrid.value == 99) {
                        this.columnSize = 12;
                    }
                    
                    this.item.grid = this.activeGrid.value;

                    this.onChangeWidth();
                }
            },
            immediate: true,
            deep: true
        },
        activeGridMobile: {
            handler() {
                if (this.activeGridMobile) {
                    this.inputValueMobile = this.activeGridMobile.porcent;
                    this.columnSizeMobile = this.activeGridMobile.value;
                    
                    this.item.gridMobile = this.activeGridMobile.value;

                    this.onChangeWidth();
                }
            },
            immediate: true,
            deep: true
        },
        inputValue() {
            this.inputValue = Math.min(this.maxValue, Math.max(this.minValue, this.inputValue));
        },
        inputValueMobile() {
            this.inputValueMobile = Math.min(this.maxValue, Math.max(this.minValue, this.inputValueMobile));
        },
    },
    computed: {
        isFullWidth() {
            return this.item.grid === 99
        }
    },
    created() {
        this.setInitialValue();

        this.setInitialValueMobile();

        if (this.hasFullWidth) {
            this.grids = this.gridSizes;
        } else {
            this.grids = this.gridSizes.filter((grid) => grid.value !== 99);
        }
    },
}
</script>

<style scoped>
.setting-width .setting-width--container-input {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    padding: 5px;
    border-bottom: 1px solid #ccc;
}

.setting-width .setting-width--container-input:has(.setting-width--icon-input) {
    padding-left: 40px;
}

.setting-width .setting-width--container-input:has(.setting-width--icon-input:focus) {
    border-bottom: 1px solid var(--main-color);
}

.setting-width .setting-width--container-input .setting-width--icon-input {
    position: absolute;
    left: 10px;
    height: 24px;
    widows: 24px;
}

.setting-width .setting-width--container-input .setting-width--input {
    width: 80%;
    cursor: pointer;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    padding: 0.5rem;
}

.setting-width .setting-width--container-input .setting-width--input-text {
    width: 100%;
    cursor: pointer;
    font-size: 1rem;
    font-weight: normal;
    border: none;
    padding: 0.5rem;
}

/* Remove as setinhas do input type="number" no Chrome e Safari */
.setting-width .setting-width--container-input .setting-width--input::-webkit-inner-spin-button,
.setting-width .setting-width--container-input .setting-width--input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Remove as setinhas do input type="number" no Firefox */
.setting-width .setting-width--container-input  .setting-width--input::-moz-number-spin-box {
  -moz-appearance: textfield;
}


.setting-width .setting-width--container-input .setting-width--container-buttons {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
}


.setting-width .setting-width--container-input .setting-width--button-up,
.setting-width .setting-width--container-input .setting-width--button-down {
    border: none;
    height: 20px;
    width: 20px;
    cursor: pointer;
}

.setting-width .setting-width--container-input .setting-width--button-up:hover,
.setting-width .setting-width--container-input .setting-width--button-down:hover {
    filter: brightness(0.8);
} 

.setting-width--container--popover {
    height: 300px;
    overflow-y: scroll;
    display: flex;
    padding: 15px 15px;
    align-items: center;
    position: absolute; 
    z-index: 99;
    background-color: var(--light);
    border-radius: 5px;
    box-shadow: 0 6px 20px 1px #dedede;
    left: 0;
}

.setting-width--popover-item {
    cursor: pointer;
    padding: 5px 10px;
    margin: 5px 0;
    border-radius: 5px;
    width: 16rem;
}

.setting-width--popover-item.active {
    border-color: var(--main-color);
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameWidth.vue